import React from 'react'
import { Link } from 'react-router-dom'
import trastorno_sueño from '../assets/images/psicologo/trastorno_sueño.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${trastorno_sueño})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Trastorno del sueño</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">Trastorno del sueño</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          Los trastornos del sueño comprenden diversas alteraciones como insomnio, hipersomnia y problemas en el ritmo circadiano. Afectan el descanso y repercuten directamente en la salud física, mental y emocional.
        </p>
        <br />
        <h4 className='text-warning'>¿Qué es el trastorno del sueño?</h4>
        <p className="text-muted">
          Estas alteraciones pueden deberse a estrés, problemas médicos, hábitos inadecuados o desequilibrios en la actividad cerebral que regula el ciclo sueño-vigilia. La neuromodulación busca restablecer patrones cerebrales que favorezcan un sueño reparador.
        </p>
        <br />
        <h4>Síntomas comunes</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Físicos: cansancio constante, somnolencia diurna excesiva.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Cognitivos: dificultad para concentrarse, pérdida de memoria reciente.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Conductuales: quedarse dormido en momentos inadecuados, evitar actividades por fatiga.
        </p>
        <br />
        
        <h4>Neuromodulación</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Magnética Transcraneal (EMT): estimulación en áreas relacionadas con la regulación del sueño.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Transcraneal por Corriente Directa (tDCS): modulación de redes cerebrales para mejorar la calidad del descanso.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Neurofeedback: entrenamiento para favorecer patrones de ondas cerebrales asociados al sueño profundo.
        </p>
      </div>
    </div>
  </div>
</section>
    
    <Footer/>
    </>
  )
}
